// extracted by mini-css-extract-plugin
export default {"settingscontainer":"style_settingscontainer__LrV5t"};